import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { store } from "./store/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import config from './config';
import { Amplify, API, Auth } from 'aws-amplify';
import { uuidv4 } from "@antv/xflow-core";

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    authenticationFlowType: 'CUSTOM_AUTH',
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: new URL('/', config.apiGateway.URL).toString(),
        region: config.apiGateway.REGION,
custom_header: async () => {

          // sessionId (you already had this)
          let sessionId = localStorage.getItem("sessionId");
          if (!sessionId) {
            sessionId = uuidv4();
            localStorage.setItem("sessionId", sessionId);
          }

          try {

            const user = await Auth.currentAuthenticatedUser();

            const cognitoauthenticationprovider =
              `cognito-idp.${config.cognito.REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}:${user.username}`;

            const userarn =
              `arn:aws:cognito-idp:${config.cognito.REGION}:${config.cognito.ACCOUNT_ID}:userpool/${config.cognito.USER_POOL_ID}/${user.username}`;

            return {
              sessionId,
              cognitoauthenticationprovider,
              userarn
            };

          } catch (e) {

            // user not logged in yet
            return { sessionId };

          }
        },
      },
    ],
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    customPrefix: {
      public: '',
    },
  },
});

(window as any).Auth = Auth;

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


// API.post("api", "courses/images/", { body: { key: "test/1ea29fb0-7907-43a0-9bbc-2714787d0607" } })